import BASKET1 from "../../../assets/plain-pipe-basket.png";
import BASKET2 from "../../../assets/pipe-cutlery.png";
import BASKET3 from "../../../assets/pipe-cup-and-saucer.png";
import BASKET4 from "../../../assets/pipe-plate-basket.png";
import BASKET5 from "../../../assets/pipe-thali-basket.png";
import BASKET6 from "../../../assets/grain-trolley-pipe-basket.webp";
import BASKET7 from "../../../assets/grain-trolly-with-wase.png";
import BASKET8 from "../../../assets/partition-pipe-basket.png";
import BASKET9 from "../../../assets/pottel-pullout-2-shelf.png";
import BASKET10 from "../../../assets/pottel-pullout-3-shelf.png";




export const PipeBaskets = [
  {
  code: "PB-01",
  name: "PLAIN PIPE BASKET",
  category: "pipe-basket",

  short:
    "Plain Pipe Basket is a strong and practical kitchen storage solution designed for organizing utensils, groceries, and daily essentials efficiently. Made from high-quality metal pipes with a rust-resistant finish, it ensures durability and long-lasting performance. Its open structure provides excellent visibility and easy access, making it ideal for modular kitchen cabinets.",

  features: [
    "High-quality metal pipe construction",
    "Rust-resistant and long-lasting finish",
    "Open design for easy visibility and access",
    "Strong and stable structure",
    "Ideal for storing utensils, groceries, and containers",
    "Suitable for modular kitchen cabinets",
    "Easy to install and maintain"
  ],

  /* ✅ PRICE */
  price: "₹3504",
  oldPrice: "₹3807",

  /* ✅ SKU + STOCK */
  sku: "PACP 01",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET1,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Plain%20Pipe%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal Pipe" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Pipe Basket" },
    { label: "Application", value: "Kitchen Cabinet / Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Plain Pipe Basket", code: "PACP 01", size: "15 / 17/ 19/ 21/ 24", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Plain Pipe Basket?",
      answer:
        "It is a metal pipe storage basket used to organize kitchen items efficiently."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen cabinets, pantry units, and modular storage systems."
    },
    {
      question: "What are its benefits?",
      answer:
        "It provides strong support, easy visibility, and organized storage."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant metal for long-term use."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed in standard kitchen cabinets."
    }
  ]
},

 {
  code: "PB-02",
  name: "CUTLERY PIPE BASKET",
  category: "pipe-basket",

  short:
    "Pipe Cutlery Basket is a practical and efficient kitchen storage solution designed to organize spoons, forks, knives, and other cutlery items neatly. Made from high-quality metal pipes with a rust-resistant finish, it ensures durability and long-lasting performance. Its open design allows easy visibility and quick access, making it ideal for modular kitchen cabinets.",

  features: [
    "Ideal for storing spoons, forks, and cutlery",
    "High-quality metal pipe construction",
    "Rust-resistant and durable finish",
    "Open design for easy visibility and access",
    "Keeps cutlery organized and clutter-free",
    "Suitable for modular kitchen cabinets",
    "Easy to install and maintain"
  ],

  /* ✅ PRICE */
  price: "₹3963",
  oldPrice: "₹4000",

  /* ✅ SKU + STOCK */
  sku: "PACP 16 - 20",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET2,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Cutlery%20Pipe%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal Pipe" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Cutlery Basket" },
    { label: "Size", value: "15 / 17 / 19 / 21 / 24" },
    { label: "Application", value: "Kitchen Cabinet / Drawer" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Cutlery Pipe Basket", code: "PACP-16", size: "15", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-17", size: "17", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-18", size: "19", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-19", size: "21", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-20", size: "24", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Cutlery Pipe Basket?",
      answer:
        "It is a metal pipe basket designed to organize spoons, forks, knives, and other cutlery items."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen cabinets, drawers, and modular kitchen units."
    },
    {
      question: "What are its benefits?",
      answer:
        "It keeps cutlery organized, improves accessibility, and prevents clutter."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant metal for long-lasting use."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed in standard kitchen cabinets."
    }
  ]
},

 {
  code: "BP-03",
  name: "CUTLERY PIPE BASKET",
  category: "pipe-basket",

  short:
    "Pipe Cutlery Basket is a practical kitchen storage solution designed to organize spoons, forks, knives, and other cutlery items neatly. Made from high-quality metal pipes with a rust-resistant finish, it ensures durability and long-lasting performance. Its open design allows easy visibility and quick access, making it ideal for modern modular kitchen cabinets.",

  features: [
    "Ideal for storing spoons, forks, and cutlery",
    "High-quality metal pipe construction",
    "Rust-resistant and durable finish",
    "Open design for easy visibility and access",
    "Keeps cutlery organized and clutter-free",
    "Suitable for modular kitchen cabinets",
    "Easy to install and maintain"
  ],

  /* ✅ PRICE */
  price: "₹5090",
  oldPrice: "₹5590",

  /* ✅ SKU + STOCK */
  sku: "PACP 21-25",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET2,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Cutlery%20Pipe%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal Pipe" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Cutlery Basket" },
    { label: "Size", value: "15 / 17 / 19 / 21 / 24" },
    { label: "Application", value: "Kitchen Cabinet / Drawer" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Cutlery Pipe Basket", code: "PACP-21", size: "15", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-22", size: "17", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-23", size: "19", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-24", size: "21", finish: "Nickel Chrome" },
    { item: "Cutlery Pipe Basket", code: "PACP-25", size: "24", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Cutlery Pipe Basket?",
      answer:
        "It is a metal pipe basket designed to organize spoons, forks, knives, and other cutlery items."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen cabinets, drawers, and modular kitchen units."
    },
    {
      question: "What are its benefits?",
      answer:
        "It keeps cutlery organized, improves accessibility, and prevents clutter."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant metal for long-lasting use."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed in standard kitchen cabinets."
    }
  ]
},


{
  code: "PB-04",
  name: "PLATE",
  category: "pipe-basket",

  short:
    "Plate Pipe Basket is a convenient kitchen storage solution designed to keep plates neatly organized inside cabinets. Made from high-quality metal pipes with a durable, rust-resistant finish, it ensures strength and long-lasting performance. Its smart design provides proper placement and easy access, making it ideal for modern modular kitchens.",

  features: [
    "Ideal for storing plates",
    "High-quality metal pipe construction",
    "Rust-resistant and durable finish",
    "Dedicated slots for safe arrangement",
    "Prevents damage and breakage",
    "Keeps kitchen cabinets organized",
    "Easy access and proper arrangement",
    "Suitable for modular kitchen cabinets",
    "Easy to install and maintain"
  ],

  /* ✅ PRICE */
  price: "₹5702",
  oldPrice: "₹5900",

  /* ✅ SKU + STOCK */
  sku: "PACP 26-30",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET3,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Plate%20Pipe%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal Pipe" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Plate Basket" },
    { label: "Size", value: "15 / 17 / 19 / 21 / 24" },
    { label: "Application", value: "Kitchen Cabinet" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Plate Pipe Basket", code: "PACP-26", size: "15", finish: "Nickel Chrome" },
    { item: "Plate Pipe Basket", code: "PACP-27", size: "17", finish: "Nickel Chrome" },
    { item: "Plate Pipe Basket", code: "PACP-28", size: "19", finish: "Nickel Chrome" },
    { item: "Plate Pipe Basket", code: "PACP-29", size: "21", finish: "Nickel Chrome" },
    { item: "Plate Pipe Basket", code: "PACP-30", size: "24", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Plate Pipe Basket?",
      answer:
        "It is a kitchen storage basket designed to organize plates safely inside cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen cabinets, pull-out units, and modular kitchen setups."
    },
    {
      question: "What are its benefits?",
      answer:
        "It keeps plates organized, prevents breakage, saves space, and provides easy access."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant metal for long-lasting use."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed in standard kitchen cabinets."
    }
  ]
},

   {
  code: "PB-05",
  name: "THALI PIPE BASKET",
  category: "pipe-basket",

  short:
    "Thali Pipe Basket is a durable kitchen storage solution designed to neatly organize thalis and large plates inside cabinets. Made from high-quality metal pipes with a strong rust-resistant finish, it ensures long-lasting performance. Its structured design provides secure placement, easy access, and helps maintain a clean and organized modular kitchen setup.",

  features: [
    "Ideal for storing thalis and large plates",
    "High-quality metal pipe construction",
    "Rust-resistant and durable finish",
    "Strong load-bearing capacity",
    "Keeps thalis properly arranged",
    "Prevents scratches and damage",
    "Easy access and smooth handling",
    "Suitable for modular kitchen cabinets"
  ],

  /* ✅ PRICE */
  price: "₹6309",
  oldPrice: "₹6800",

  /* ✅ SKU + STOCK */
  sku: "PACP 31 - 35",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET5,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Thali%20Pipe%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal Pipe" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Thali Basket" },
    { label: "Size", value: "15 / 17 / 19 / 21 / 24" },
    { label: "Application", value: "Kitchen Cabinet" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Thali Pipe Basket", code: "PACP-31", size: "15", finish: "Nickel Chrome" },
    { item: "Thali Pipe Basket", code: "PACP-32", size: "17", finish: "Nickel Chrome" },
    { item: "Thali Pipe Basket", code: "PACP-33", size: "19", finish: "Nickel Chrome" },
    { item: "Thali Pipe Basket", code: "PACP-34", size: "21", finish: "Nickel Chrome" },
    { item: "Thali Pipe Basket", code: "PACP-35", size: "24", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Thali Pipe Basket?",
      answer:
        "It is a metal pipe kitchen basket designed to store thalis and large plates in an organized manner."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen cabinets, pull-out units, and modular kitchen storage systems."
    },
    {
      question: "What are its benefits?",
      answer:
        "It keeps thalis organized, prevents damage, saves space, and allows easy access."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant metal pipes for long life."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed in standard modular kitchen cabinets."
    }
  ]
},

  {
  code: "PB-06",
  name: "GRAIN TROLLEY",
  category: "pipe-basket",

  short:
    "Grain Trolley is a smart kitchen storage solution designed to store grains, pulses, and dry food items in an organized way. It comes with multiple containers that help keep ingredients fresh and easily accessible. Made from strong and durable materials, it ensures long-lasting use and smooth movement, making it ideal for modern modular kitchen cabinets.",

  features: [
    "Ideal for storing grains and pulses",
    "Multiple containers for better organization",
    "Strong and durable construction",
    "Smooth and easy movement",
    "Suitable for modular kitchen cabinets"
  ],

  /* ✅ PRICE */
  price: "₹7451",
  oldPrice: "8000",

  /* ✅ SKU + STOCK */
  sku: "PACP 36-40",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET6,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Grain%20Trolley%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Grain Trolley" },
    { label: "Application", value: "Kitchen Cabinet / Pantry Unit" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    {
      item: "Grain Trolley",
      code: "PACP 36",
      size: "15.20.10",
      finish: "Nickel Chrome"
    },
     {
      item: "Grain Trolley",
      code: "PACP 37",
      size: "17.20.10",
      finish: "Nickel Chrome"
    },
     {
      item: "Grain Trolley",
      code: "PACP 38",
      size: "19.20.10",
      finish: "Nickel Chrome"
    },
     {
      item: "Grain Trolley",
      code: "PACP 39",
      size: "21.20.10",
      finish: "Nickel Chrome"
    },
     {
      item: "Grain Trolley",
      code: "PACP 39",
      size: "24.20.10",
      finish: "Nickel Chrome"
    },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Grain Trolley?",
      answer:
        "A Grain Trolley is a kitchen storage unit designed with multiple containers to store grains, pulses, and dry food items."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen cabinets, pantry units, and modular kitchen setups."
    },
    {
      question: "What are its benefits?",
      answer:
        "It provides organized storage, easy access, and keeps grains fresh and hygienic."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong rust-resistant material for long-lasting use."
    },
    {
      question: "Is it easy to use?",
      answer:
        "Yes, it has smooth movement and easy pull-out functionality."
    }
  ]
},

  {
  code: "PB-07",
  name: "GRAIN TROLLEY WITH BASE",
  category: "pipe-basket",

  short:
    "Grain Trolley with Base is a convenient kitchen storage solution designed to store grains, pulses, and dry food items in an organized manner. It comes with a strong base that provides extra support and stability. Made from durable materials, it ensures long-lasting performance and smooth movement, making it perfect for modern modular kitchen cabinets.",

  features: [
    "Ideal for storing grains and pulses",
    "Strong base for extra support",
    "Durable and long-lasting construction",
    "Smooth and easy movement",
    "Keeps kitchen items organized"
  ],

  /* ✅ PRICE */
  price: "₹13280",
  oldPrice: "14000",

  /* ✅ SKU + STOCK */
  sku: "PACP - 41-44",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET7,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Grain%20Trolley%20With%20Base%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Grain Trolley With Base" },
    { label: "Application", value: "Kitchen Cabinet / Pantry Unit" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    {
      item: "Grain Trolley with Base",
      code: "PACP 41",
      size: "15.20.12",
      finish: "Nickel Chrome"
    },
    {
      item: "Grain Trolley with Base",
      code: "PACP 42",
      size: "17.20.12",
      finish: "Nickel Chrome"
    },
    {
      item: "Grain Trolley with Base",
      code: "PACP 43",
      size: "19.20.12",
      finish: "Nickel Chrome"
    },

    {
      item: "Grain Trolley with Base",
      code: "PACP 44",
      size: "21.20.12",
      finish: "Nickel Chrome"
    },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Grain Trolley with Base?",
      answer:
        "A Grain Trolley with Base is a kitchen storage trolley designed with a strong base for stability to store grains, pulses, and dry food items."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchens, pantry units, and modular cabinets for organized bulk storage."
    },
    {
      question: "What are its benefits?",
      answer:
        "It provides stability, smooth movement, organized storage, and easy access to food grains."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong rust-resistant material for long-term use."
    },
    {
      question: "Is it easy to use?",
      answer:
        "Yes, it has a smooth sliding/movement mechanism with strong support base."
    }
  ]
},

 {
  code: "PB-08",
  name: "PARTITION",
  category: "pipe-basket",

  short:
    "Partition Basket is a practical kitchen storage accessory designed to organize different kitchen items separately within the same basket. It helps keep utensils, groceries, or other essentials neatly arranged and easy to access. Made from durable material with a strong finish, it ensures long-lasting use and improves overall kitchen organization in modern modular cabinets.",

  features: [
    "Helps divide and organize items easily",
    "Strong and durable construction",
    "Improves kitchen storage management",
    "Easy to install and maintain",
    "Suitable for modular kitchen baskets"
  ],

  /* ✅ PRICE */
  price: "₹4610",
  oldPrice: "5000",

  /* ✅ SKU + STOCK */
  sku: "PACP 45 - 49",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET8,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Partition%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Partition Basket" },
    { label: "Application", value: "Kitchen Cabinet / Drawer Unit" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    {
      item: "Partition Basket",
      code: "PACP 45",
      size: "15.20.6",
      finish: "Nickel Chrome"
    },
    {
      item: "Partition Basket",
      code: "PACP 46",
      size: "17.20.6",
      finish: "Nickel Chrome"
    },
    {
      item: "Partition Basket",
      code: "PACP 47",
      size: "19.20.6",
      finish: "Nickel Chrome"
    },
    {
      item: "Partition Basket",
      code: "PACP 48",
      size: "21.20.6",
      finish: "Nickel Chrome"
    },
    {
      item: "Partition Basket",
      code: "PACP 49",
      size: "24.20.6",
      finish: "Nickel Chrome"
    },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Partition Basket?",
      answer:
        "A Partition Basket is a kitchen storage basket with dividers used to separate and organize different kitchen items efficiently."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, cabinets, and modular storage units for organized storage."
    },
    {
      question: "What are its benefits?",
      answer:
        "It keeps items separated, reduces clutter, and improves storage efficiency."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong rust-resistant material for long-lasting use."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store cutlery, utensils, small containers, and kitchen tools."
    }
  ]
},
  {
  code: "PB-09",
  name: "BOTTLE PULL OUT 2 SHELF",
  category: "pipe-basket",

  short:
    "Bottle Pull Out 2 Shelf is a compact kitchen storage solution designed to keep bottles, jars, and condiments neatly organized. It features two sturdy shelves that provide easy access and efficient use of cabinet space. Made from durable and rust-resistant material, it ensures smooth sliding and long-lasting performance, making it ideal for modern modular kitchens.",

  features: [
    "Two shelves for bottle storage",
    "Smooth pull-out sliding mechanism",
    "Strong and durable construction",
    "Rust-resistant and long-lasting finish",
    "Space-saving design for cabinets"
  ],

  /* ✅ PRICE */
  price: "₹5391",
  oldPrice: "6000",

  /* ✅ SKU + STOCK */
  sku: "PACP 50- 53",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET9,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Bottle%20Pull%20Out%202%20Shelf%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Bottle Pull Out (2 Shelf)" },
    { label: "Application", value: "Kitchen Cabinet / Pantry Unit" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    {
      item: "Bottle Pull Out 2 Shelf",
      code: "PACP 50",
      size: "4.20.18",
      finish: "Nickel Chrome"
    },
     {
      item: "Bottle Pull Out 2 Shelf",
      code: "PACP 51",
      size: "6.20.18",
      finish: "Nickel Chrome"
    },
     {
      item: "Bottle Pull Out 2 Shelf",
      code: "PACP 52",
      size: "8.20.18",
      finish: "Nickel Chrome"
    },
     {
      item: "Bottle Pull Out 2 Shelf",
      code: "PACP 53",
      size: "11.20.18",
      finish: "Nickel Chrome"
    },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Bottle Pull Out – 2 Shelves?",
      answer:
        "It is a kitchen storage unit with two pull-out shelves designed to organize bottles, jars, and containers in a compact space."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen cabinets and modular storage units for easy access to bottles and condiments."
    },
    {
      question: "What are its benefits?",
      answer:
        "It saves space, improves organization, provides smooth access, and keeps bottles secure."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant metal for long-term durability."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store water bottles, oil bottles, sauces, and other kitchen jars."
    }
  ]
},
{
  code: "PB-010",
  name: "BOTTLE PULL OUT 3 SHELF",
  category: "pipe-basket",

  short:
    "Bottle Pull Out 3 Shelf is a practical kitchen storage solution designed to organize bottles, jars, and condiments efficiently. It features three spacious shelves that provide better storage capacity and easy access. Made from strong and durable material with a rust-resistant finish, it ensures smooth sliding and long-lasting performance, perfect for modern modular kitchens.",

  features: [
    "Three shelves for better bottle storage",
    "Smooth pull-out sliding mechanism",
    "Strong and durable construction",
    "Rust-resistant and long-lasting finish",
    "Space-saving cabinet design"
  ],

  /* ✅ PRICE */
  price: "₹7364",
  oldPrice: "₹8000",

  /* ✅ SKU + STOCK */
  sku: "PACP 58 61",
  stock: "In Stock",

  /* ✅ IMAGE */
  image: BASKET10,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Bottle%20Pull%20Out%203%20Shelf%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Bottle Pull Out (3 Shelf)" },
    { label: "Size Codes", value: "58 / 59 / 60 / 61" },
    { label: "Sizes", value: "4-20-21 / 6-20-21 / 8-10-21 / 11-10-21" },
    { label: "Application", value: "Kitchen Cabinet / Pantry Unit" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    {
      item: "Bottle Pull Out 3 Shelf",
      code: "PACP-58",
      size: "4.20.21",
      price: "₹7364",
      finish: "Nickel Chrome"
    },
    {
      item: "Bottle Pull Out 3 Shelf",
      code: "PACP-59",
      size: "6.20.21",
      price: "₹7364",
      finish: "Nickel Chrome"
    },
    {
      item: "Bottle Pull Out 3 Shelf",
      code: "PACP-60",
      size: "8.10.21",
      price: "₹7364",
      finish: "Nickel Chrome"
    },
    {
      item: "Bottle Pull Out 3 Shelf",
      code: "PACP-61",
      size: "11.10.21",
      price: "₹7364",
      finish: "Nickel Chrome"
    }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Bottle Pull Out – 3 Shelves?",
      answer:
        "It is a kitchen storage unit with three pull-out shelves designed to organize bottles, jars, and containers efficiently."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen cabinets and modular pantry units for organized storage."
    },
    {
      question: "What are its benefits?",
      answer:
        "It maximizes storage space, keeps bottles organized, and provides smooth easy access."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant metal for long-term use."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store water bottles, oil bottles, spice jars, and other kitchen containers."
    }
  ]
}

]